var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#4884E8",
    fillRule: "nonzero",
    stroke: "#4884E8",
    strokeWidth: 0.25
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.016 18.217l-4.76-4.95c1.223-1.456 1.894-3.286 1.894-5.192C16.15 3.623 12.527 0 8.075 0 3.623 0 0 3.623 0 8.075c0 4.452 3.623 8.075 8.075 8.075 1.672 0 3.264-.504 4.626-1.461l4.796 4.988c.2.208.47.323.76.323.273 0 .532-.104.73-.294.418-.403.431-1.07.029-1.49zM8.075 2.107c3.291 0 5.968 2.677 5.968 5.968s-2.677 5.968-5.968 5.968-5.968-2.677-5.968-5.968 2.677-5.968 5.968-5.968z",
    transform: "translate(-112.000000, -125.000000) translate(96.000000, 112.000000) translate(16.000000, 13.000000) translate(2.000000, 2.000000)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.c97dd56e.svg";
export { ForwardRef as ReactComponent };